module.exports = __webpack_public_path__ + "img/swm-ic.59519a26.png";